/* eslint-disable jsx-a11y/anchor-is-valid */
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaSnapchatGhost } from "react-icons/fa";
import { useState } from "react";

export default function Header() {
  const [tooggle, settoggle] = useState(false);
  const cart = useSelector((state) => state?.cart?.cart);
  const location = useLocation();
  const token = localStorage.getItem("token");

  return (
    <>
      <section className="topbar">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-sm-6 col-md-8">
              <ul className="topbar_info d-flex flex-wrap d-none d-sm-flex">
                <li>
                  <a href="mailto:info@afrikanbbq.com">
                    <i className="fas fa-envelope" /> info@afrikanbbq.com
                  </a>
                </li>
                <li className="d-none d-md-block">
                  <a href="callto:(509)601-2505">
                    <i className="fas fa-phone-alt" /> (509) 601-2505
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-xl-6 col-sm-6 col-md-4">
              <ul className="topbar_icon d-flex flex-wrap h-100">
                <li className="my-auto">
                  <a
                    href="#"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <FaFacebook size={20} />
                  </a>
                </li>
                <li className="my-auto">
                  <a
                    href="#"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <FaTiktok size={20} />
                  </a>
                </li>
                <li className="my-auto">
                  <a
                    href="#"
                    className="d-flex align-items-center justify-content-center"
                  >
                    <FaYoutube size={20} />
                  </a>
                </li>

                <li className="my-auto">
                  <a href="#">
                    <FaSnapchatGhost />
                  </a>
                </li>
                <li className="my-auto">
                  <a href="#">
                    <i className="fab fa-instagram" />
                  </a>
                </li>
                {/* <li>
                  <a href="#">
                    <i className="fab fa-behance" />
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <nav className="navbar navbar-expand-lg main_menu py-0">
        <div className="container">
          <Link className="navbar-brand" to={"/"}>
            <img
              src="/images/transparentlogo.png"
              alt="RegFood"
              className="headerLogo w-100"
            />
          </Link>
          <button
            onClick={() => settoggle(!tooggle)}
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i className="far fa-bars menu_icon_bar" />
            <i className="far fa-times close_icon_close" />
          </button>
          <div
            className={`collapse navbar-collapse ${tooggle ? "show" : "hide"}`}
          >
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location?.pathname === "/" && "active"
                  } `}
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location?.pathname === "/about" && "active"
                  } `}
                  to="/about"
                >
                  about
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location?.pathname === "/menu" && "active"
                  } `}
                  to="/menu"
                >
                  menu
                </Link>
              </li>
              {/* <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location?.pathname === "/eventpackage" && "active"
                  } `}
                  to="/eventpackage"
                >
                  Event
                </Link>
              </li> */}

              <li className="nav-item">
                <Link
                  className={`nav-link ${
                    location?.pathname === "/contact" && "active"
                  } `}
                  to="/contact"
                >
                  contact
                </Link>
              </li>
            </ul>
            <ul className="menu_icon d-flex flex-wrap">
              <li>
                <Link
                  className="cart_icon"
                  to={token ? "/wishlist" : "/favourite"}
                >
                  <i className="fas fa-heart" />
                </Link>
              </li>
              <li>
                <Link className="cart_icon" to="/cartview">
                  <i className="fas fa-shopping-basket" />
                  <span>{cart?.length}</span>
                </Link>
              </li>
              {token ? (
                <li>
                  <Link to="/userprofile">
                    <i className="fas fa-user" />
                  </Link>
                </li>
              ) : (
                <Link className="ps-3 fw-bold" to="/signin">
                  Login
                </Link>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
